import { LuMap } from 'react-icons/lu'
import Button, { ButtonProps } from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import useGraphView from '../models/useGraphView'

/**
 * Draw the nodes on a map, or as the graph (nobgp-router#1934).
 *
 * `setMapView` and not a bare `set`, because the choice is remembered (`lib/viewPrefs.ts`).
 */
export default function MapView(props: ButtonProps) {
  const { mapView, setMapView } = useGraphView()

  return (
    // ⚠ Never disabled while the map is on: with no node the reader could not go back to the graph.
    <Button onClick={() => setMapView(!mapView)} {...props} disabled={props.disabled && !mapView}>
      <Typography variant="caption" color="textSecondary" sx={{ lineHeight: 1.2 }}>
        {mapView ? 'Show Graph' : 'Show Map'}
      </Typography>
      <Stack
        sx={{
          width: 38,
          height: 38,
          alignItems: 'center',
          justifyContent: 'center',
          color: mapView ? 'primary.main' : 'contrast.medium',
        }}>
        <LuMap fontSize={20} />
      </Stack>
    </Button>
  )
}
